import type { Range } from '~/entities/epg/programs'
import type { LiveProgramCardInfo, TvChannelWithLiveEpg } from '../index.h'

import { rangeCovered } from '~/entities/epg/programs'

export const programsLoaded = (range: Range) => {
  const covered = rangeCovered(range)
  const toRange = (program: LiveProgramCardInfo) =>
    [program.startMs, program.stopMs] as Range

  return (channel: TvChannelWithLiveEpg) => {
    const loaded = channel.program.map(toRange)
    return covered(loaded)
  }
}
